import { render } from "./UserSpace.vue?vue&type=template&id=6cb4934e&scoped=true"
import script from "./UserSpace.vue?vue&type=script&lang=js"
export * from "./UserSpace.vue?vue&type=script&lang=js"

import "./UserSpace.vue?vue&type=style&index=0&id=6cb4934e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb4934e"]])

export default __exports__